import { breakpoints, colors, Margin } from '@spritz-finance/ui'
import styled from 'styled-components'

export const AuthenticationContainer = styled.div`
    //text-align: center;
`

export const AuthenticationForm = styled.div`
    @media screen and (max-width: 599px) {
        width: 100%;
    }
`

export const AuthenticationTerms = styled.div`
    text-align: left;
`

export const Link = styled.span`
    margin-left: 5px;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`

export const AuthenticationBottomText = styled.div`
    font-size: 12px;
    line-height: 15px;
    margin-top: 74.5px;
    display: flex;
    align-content: center;
    justify-content: center;
    @media screen and (max-width: 599px) {
        margin-top: 30px;
    }
`

export const AuthenticationBottomLink = styled.div`
    margin-left: 5px;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`

export const LinkingMessage = styled.div`
    background: ${colors.ltAqua[25]};
    padding: ${Margin.Small};
`

export const FormContent = styled.div`
    display: flex;
    margin: 0 auto;
    align-items: center;
    flex-direction: column;
    & > * {
        width: 100%;
    }

    ${breakpoints.small} {
        width: auto;
    }
`
